import { IComponentOptions, IController } from "angular";
import { FeatureFlag } from "@gtmhub/featureToggle/models";
import { FeatureToggleV2Service } from "@gtmhub/featureToggle/featureToggleV2Service";

export class GlobalSearchStateWrapperCtrl implements IController {
  public static $inject = ["FeatureToggleV2Service"];

  public isSearchRecentItemsFeatureEnabled = false;
  public isDataLoading: boolean;

  constructor(private featureToggleService: FeatureToggleV2Service) {
    this.isDataLoading = true;

    this.featureToggleService.isFeatureAvailable(FeatureFlag.FeatureSearchRecentItems).then(
      (enabled) => {
        this.isSearchRecentItemsFeatureEnabled = enabled;
        this.isDataLoading = false;
      },
      () => {
        this.isDataLoading = false;
      }
    );
  }
}

export const GlobalSearchStateWrapperComponent: IComponentOptions = {
  templateUrl: require("./global-search-state-wrapper.jade"),
  controller: GlobalSearchStateWrapperCtrl,
};
